module.exports = __webpack_public_path__ + "media/src/assets/images/comment_staff-93588dd9e13d98f515453c84e2ae2fd1.png";